import {
  FETCH_NOTIFICATION_MONITORING_REQUEST,
  FETCH_NOTIFICATION_MONITORING_SUCCESS,
  FETCH_NOTIFICATION_MONITORING_FAILURE,
} from '../../constants/ActionTypes';

const notificationMonitoring = (
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) => {
  switch (action.type) {
    case FETCH_NOTIFICATION_MONITORING_REQUEST:
      return { ...state, isFetching: true, errorMessage: null };
    case FETCH_NOTIFICATION_MONITORING_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: action.data.data,
        paging: action.data.paging,
      };
    case FETCH_NOTIFICATION_MONITORING_FAILURE:
      return { ...state, isFetching: false, errorMessage: action.message };
    default:
      return state;
  }
};

export default notificationMonitoring;
